// extracted by mini-css-extract-plugin
export default {"container":"Typography_container__5wg6J"};